/*!
 * Gemwix / Tushar Gems: location-based currency display (Oct 2026)
 * - Detects the visitor's country (Shopify geo lookup, then time zone) and shows
 *   prices in that country's currency at today's rate.
 * - Footer shows "Flag  Country (CUR)"; clicking opens "Select Your Location".
 * - DISPLAY ONLY: checkout is still billed in INR (Shopify Payments is not
 *   available to Indian merchants). The location panel says so.
 * Rates: open.er-api.com (base INR), fallback api.frankfurter.dev. Cached 6 h.
 * Loaded from snippets/sr-checkout.liquid on every page.
 */
(function () {
  'use strict';

  var CACHE_HOURS = 6, FX_KEY = 'gwx_fx_v2', PREF_KEY = 'gwx_country', GEO_KEY = 'gwx_geo_v1';
  var FALLBACK = { USD: 1 / 94.55 };

  var REGIONS = [
    ['North America', [['CA', 'Canada', 'CAD'], ['US', 'United States', 'USD']]],
    ['Europe', [['GB', 'United Kingdom', 'GBP'], ['DE', 'Deutschland', 'EUR'], ['FR', 'France', 'EUR'], ['IE', 'Ireland', 'EUR'],
      ['BE', 'Belgium', 'EUR'], ['LU', 'Luxembourg', 'EUR'], ['NL', 'Netherlands', 'EUR'], ['AT', 'Austria', 'EUR'],
      ['IT', 'Italy', 'EUR'], ['ES', 'Spain', 'EUR'], ['CH', 'Switzerland', 'CHF'], ['FI', 'Finland', 'EUR'],
      ['EE', 'Estonia', 'EUR'], ['PT', 'Portugal', 'EUR'], ['GR', 'Greece', 'EUR'], ['DK', 'Denmark', 'DKK'],
      ['CZ', 'Czech Republic', 'CZK'], ['RS', 'Serbia', 'RSD'], ['SE', 'Sweden', 'SEK'], ['NO', 'Norway', 'NOK'],
      ['PL', 'Poland', 'PLN'], ['CY', 'Cyprus', 'EUR'], ['HR', 'Croatia', 'EUR']]],
    ['Asia Pacific', [['IN', 'India', 'INR'], ['AU', 'Australia', 'AUD'], ['NZ', 'New Zealand', 'NZD'], ['JP', 'Japan', 'JPY'],
      ['SG', 'Singapore', 'SGD'], ['HK', 'Hong Kong', 'HKD'], ['MY', 'Malaysia', 'MYR'], ['NP', 'Nepal', 'NPR']]],
    ['Middle East', [['AE', 'United Arab Emirates', 'AED'], ['SA', 'Saudi Arabia', 'SAR'], ['QA', 'Qatar', 'QAR'],
      ['KW', 'Kuwait', 'KWD'], ['OM', 'Oman', 'OMR'], ['BH', 'Bahrain', 'BHD']]],
    ['Rest of the World', [['XX', 'International', 'USD']]]
  ];
  var BY = {};
  REGIONS.forEach(function (r) { r[1].forEach(function (c) { BY[c[0]] = { cc: c[0], name: c[1], cur: c[2] }; }); });

  if (typeof WeakMap !== 'function' || typeof document.createTreeWalker !== 'function') return;
  try { if (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== 'INR') return; } catch (e) {}

  var rates = null, rateDate = '', country = BY.IN, mode = 'INR';
  var origMap = new WeakMap(), touched = [], observer = null, timer = null, trigger = null, modal = null;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function flag(cc) {
    if (cc === 'XX') return '<svg class="gwx-flag" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M2 12h20M12 2c3 3 3 17 0 20M12 2c-3 3-3 17 0 20" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
    return '<img class="gwx-flag" src="https://flagcdn.com/w40/' + cc.toLowerCase() + '.png" width="26" height="18" alt="" loading="lazy">';
  }

  /* ------------------------------------------------------------ location */
  function tzCountry() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (/Asia\/(Kolkata|Calcutta)/.test(tz)) return 'IN';
      var m = { 'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA', 'America/Winnipeg': 'CA', 'America/Halifax': 'CA',
        'Europe/London': 'GB', 'Europe/Berlin': 'DE', 'Europe/Paris': 'FR', 'Europe/Dublin': 'IE', 'Europe/Brussels': 'BE', 'Europe/Luxembourg': 'LU',
        'Europe/Amsterdam': 'NL', 'Europe/Vienna': 'AT', 'Europe/Rome': 'IT', 'Europe/Madrid': 'ES', 'Europe/Zurich': 'CH', 'Europe/Helsinki': 'FI',
        'Europe/Tallinn': 'EE', 'Europe/Lisbon': 'PT', 'Europe/Athens': 'GR', 'Europe/Copenhagen': 'DK', 'Europe/Prague': 'CZ', 'Europe/Belgrade': 'RS',
        'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Warsaw': 'PL', 'Asia/Nicosia': 'CY', 'Europe/Zagreb': 'HR',
        'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU', 'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU',
        'Pacific/Auckland': 'NZ', 'Asia/Tokyo': 'JP', 'Asia/Singapore': 'SG', 'Asia/Hong_Kong': 'HK', 'Asia/Kuala_Lumpur': 'MY', 'Asia/Kathmandu': 'NP',
        'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Muscat': 'OM', 'Asia/Bahrain': 'BH' };
      if (m[tz]) return m[tz];
      if (/^America\//.test(tz)) return 'US';
      if (tz) return 'XX';
    } catch (e) {}
    return 'IN';
  }

  function detect(cb) {
    var pref = lsGet(PREF_KEY);
    if (pref && BY[pref]) { cb(pref); return; }
    var g = null;
    try { g = JSON.parse(lsGet(GEO_KEY) || 'null'); } catch (e) {}
    if (g && g.cc && Date.now() - g.t < 24 * 3600000) { cb(g.cc); return; }
    var done = false;
    function fin(cc) {
      if (done) return; done = true;
      cc = (cc || '').toUpperCase();
      if (!BY[cc]) cc = cc ? 'XX' : tzCountry();
      lsSet(GEO_KEY, JSON.stringify({ cc: cc, t: Date.now() }));
      cb(cc);
    }
    if (typeof fetch !== 'function') { fin(tzCountry()); return; }
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { var c = d && d.detected_values && d.detected_values.country; fin(c && c.handle ? c.handle : tzCountry()); })
      .catch(function () { fin(tzCountry()); });
    setTimeout(function () { fin(tzCountry()); }, 3500);
  }

  /* --------------------------------------------------------------- rates */
  function getRates(cb) {
    var c = null;
    try { c = JSON.parse(lsGet(FX_KEY) || 'null'); } catch (e) {}
    if (c && c.r && Date.now() - c.t < CACHE_HOURS * 3600000) { cb(c.r, c.d || ''); return; }
    var settled = false;
    function ok(r) { return r && r.USD > 0.004 && r.USD < 0.05; }
    function done(r, d) {
      if (settled) return; settled = true;
      if (!ok(r)) { r = (c && c.r) || FALLBACK; d = (c && c.d) || ''; }
      else lsSet(FX_KEY, JSON.stringify({ r: r, d: d || '', t: Date.now() }));
      cb(r, d || '');
    }
    if (typeof fetch !== 'function') { done(null); return; }
    fetch('https://open.er-api.com/v6/latest/INR')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !ok(d.rates)) throw 0;
        done(d.rates, d.time_last_update_utc ? d.time_last_update_utc.slice(5, 16) : '');
      })
      .catch(function () {
        fetch('https://api.frankfurter.dev/v1/latest?base=INR')
          .then(function (r) { return r.json(); })
          .then(function (d) { done(d && d.rates, d && d.date); })
          .catch(function () { done(null); });
      });
    setTimeout(function () { done(null); }, 7000);
  }

  /* ------------------------------------------------------ price rewriting */
  var MONEY_RX = /(?:₹|Rs\.?|INR)\s?(\d[\d,]*(?:\.\d{1,2})?)/g;
  function hasMoney(s) { return s.indexOf('₹') > -1 || /(?:Rs\.?|INR)\s?\d/.test(s); }
  function fmt(n, cur) {
    if (!isFinite(n)) return '';
    var d = (cur === 'JPY' || n >= 100) ? 0 : 2;
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: d, maximumFractionDigits: d }).format(n); }
    catch (e) { return cur + ' ' + n.toFixed(d); }
  }
  function collect() {
    var out = [], n, w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || !node.nodeValue) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|TITLE)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('[data-gwx-skip]')) return NodeFilter.FILTER_REJECT;
        return hasMoney(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    }, false);
    while ((n = w.nextNode())) out.push(n);
    return out;
  }
  function convert() {
    var r = rates && rates[mode]; if (!r) return;
    collect().forEach(function (node) {
      if (!origMap.has(node)) origMap.set(node, node.nodeValue);
      var out = origMap.get(node).replace(MONEY_RX, function (m, num) {
        var v = parseFloat(String(num).replace(/,/g, ''));
        return (!isFinite(v) || v <= 0) ? m : fmt(v * r, mode);
      });
      if (out !== node.nodeValue) { node.nodeValue = out; if (touched.indexOf(node) < 0) touched.push(node); }
    });
  }
  function restore() { touched.forEach(function (n) { if (origMap.has(n)) n.nodeValue = origMap.get(n); }); touched = []; }
  function observe(on) { if (!observer) return; if (on) observer.observe(document.body, { childList: true, subtree: true, characterData: true }); else observer.disconnect(); }
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; observe(false); if (mode !== 'INR') convert(); observe(true); }, 150);
  }

  /* ------------------------------------------------------------------ UI */
  var CSS =
    '.gwx-loc{display:flex;justify-content:center;padding:18px 16px 4px;font-family:Jost,"Poppins",sans-serif}' +
    '.gwx-loc__btn{-webkit-appearance:none;appearance:none;background:none;border:0;cursor:pointer;display:inline-flex;align-items:center;gap:12px;font:400 15px/1.2 Jost,"Poppins",sans-serif;color:#1a1a1a;padding:6px 2px;letter-spacing:.02em}' +
    '.gwx-loc__btn .gwx-txt{border-bottom:1px solid #1a1a1a;padding-bottom:2px}' +
    '.gwx-loc__btn:hover .gwx-txt{color:#b98b3a;border-color:#b98b3a}' +
    '.gwx-loc__btn .gwx-caret{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:6px solid currentColor}' +
    '.gwx-flag{width:26px;height:18px;object-fit:cover;display:block;flex:none;box-shadow:0 0 0 1px rgba(0,0,0,.06)}' +
    'svg.gwx-flag{box-shadow:none;color:#8a6512}' +
    '.gwx-modal{position:fixed;inset:0;z-index:100000;background:rgba(20,20,20,.55);display:flex;align-items:center;justify-content:center;padding:20px;font-family:Jost,"Poppins",sans-serif}' +
    '.gwx-modal[hidden]{display:none}' +
    '.gwx-modal__box{background:#f5f4f2;width:min(1180px,100%);max-height:92vh;display:flex;flex-direction:column;box-shadow:0 30px 80px rgba(0,0,0,.35)}' +
    '.gwx-modal__head{background:#fff;display:flex;align-items:center;justify-content:space-between;padding:26px 44px;box-shadow:0 6px 18px -12px rgba(0,0,0,.25)}' +
    '.gwx-modal__head h2{margin:0;font:500 26px/1.2 Jost,"Poppins",sans-serif;letter-spacing:.01em;color:#141414;text-transform:none}' +
    '.gwx-modal__x{background:none;border:0;cursor:pointer;width:40px;height:40px;position:relative}' +
    '.gwx-modal__x:before,.gwx-modal__x:after{content:"";position:absolute;left:9px;right:9px;top:19px;height:2px;background:#141414;transform:rotate(45deg)}' +
    '.gwx-modal__x:after{transform:rotate(-45deg)}' +
    '.gwx-modal__body{overflow-y:auto;padding:30px 44px 34px;display:grid;grid-template-columns:repeat(3,1fr);gap:8px 40px;align-items:start}' +
    '.gwx-reg h3{margin:14px 0 18px;font:500 20px/1.2 Jost,"Poppins",sans-serif;letter-spacing:.04em;text-transform:uppercase;color:#141414}' +
    '.gwx-reg ul{list-style:none;margin:0 0 26px;padding:0}' +
    '.gwx-reg li{margin:0}' +
    '.gwx-opt{background:none;border:0;cursor:pointer;display:flex;align-items:center;gap:16px;padding:11px 0;font:400 16px/1.2 Jost,"Poppins",sans-serif;letter-spacing:.04em;color:#1a1a1a;text-align:left;width:100%}' +
    '.gwx-opt:hover span,.gwx-opt.is-on span{color:#b98b3a;text-decoration:underline;text-underline-offset:4px}' +
    '.gwx-modal__note{grid-column:1/-1;margin:6px 0 0;font-size:12.5px;line-height:1.6;color:#7a7a7a;border-top:1px solid #e3e0da;padding-top:16px}' +
    '@media (max-width:900px){.gwx-modal__body{grid-template-columns:1fr 1fr}}' +
    '@media (max-width:600px){.gwx-modal{padding:0}.gwx-modal__box{max-height:100vh;height:100%}.gwx-modal__head{padding:18px 20px}.gwx-modal__head h2{font-size:21px}.gwx-modal__body{grid-template-columns:1fr;padding:12px 20px 30px}.gwx-reg h3{font-size:17px}.gwx-opt{font-size:15px;padding:9px 0}}' +
    '@media print{.gwx-loc,.gwx-modal{display:none!important}}';

  function buildUI() {
    var st = document.createElement('style'); st.setAttribute('data-gwx', 'currency'); st.textContent = CSS; document.head.appendChild(st);

    var wrap = document.createElement('div');
    wrap.className = 'gwx-loc'; wrap.setAttribute('data-gwx-skip', '');
    wrap.innerHTML = '<button type="button" class="gwx-loc__btn" aria-haspopup="dialog" aria-label="Change country and currency"></button>';
    trigger = wrap.firstChild;
    var foot = document.querySelector('.tg-foot'), copy = foot && foot.querySelector('.tf-copy');
    if (copy) copy.parentNode.insertBefore(wrap, copy);
    else if (foot) foot.appendChild(wrap);
    else (document.querySelector('footer') || document.body).appendChild(wrap);

    var h = '<div class="gwx-modal__box" role="dialog" aria-modal="true" aria-labelledby="gwxLocTtl">' +
      '<div class="gwx-modal__head"><h2 id="gwxLocTtl">Select Your Location</h2><button type="button" class="gwx-modal__x" aria-label="Close"></button></div>' +
      '<div class="gwx-modal__body">';
    var cols = [[REGIONS[0], REGIONS[3], REGIONS[4]], [REGIONS[1]], [REGIONS[2]]];
    cols.forEach(function (col) {
      h += '<div>';
      col.forEach(function (r) {
        h += '<div class="gwx-reg"><h3>' + esc(r[0]) + '</h3><ul>';
        r[1].forEach(function (c) {
          h += '<li><button type="button" class="gwx-opt" data-cc="' + c[0] + '">' + flag(c[0]) + '<span>' + esc(c[1]) + ' (' + c[2] + ')</span></button></li>';
        });
        h += '</ul></div>';
      });
      h += '</div>';
    });
    h += '<p class="gwx-modal__note" id="gwxLocNote"></p></div></div>';
    modal = document.createElement('div');
    modal.className = 'gwx-modal'; modal.hidden = true; modal.setAttribute('data-gwx-skip', '');
    modal.innerHTML = h;
    document.body.appendChild(modal);

    trigger.addEventListener('click', openModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target.closest && e.target.closest('.gwx-modal__x'))) { closeModal(); return; }
      var o = e.target.closest && e.target.closest('.gwx-opt');
      if (o) { lsSet(PREF_KEY, o.getAttribute('data-cc')); setCountry(o.getAttribute('data-cc')); closeModal(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  }
  function openModal() { paint(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; var on = modal.querySelector('.gwx-opt.is-on'); (on || modal.querySelector('.gwx-modal__x')).focus(); }
  function closeModal() { modal.hidden = true; document.documentElement.style.overflow = ''; trigger.focus(); }

  function paint() {
    if (!trigger) return;
    trigger.innerHTML = flag(country.cc) + '<span class="gwx-txt">' + esc(country.name) + ' (' + mode + ')</span><span class="gwx-caret" aria-hidden="true"></span>';
    var opts = modal.querySelectorAll('.gwx-opt');
    for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('is-on', opts[i].getAttribute('data-cc') === country.cc);
    var note = modal.querySelector('#gwxLocNote');
    if (note) note.textContent = mode === 'INR'
      ? 'Prices are shown in Indian Rupees (INR).'
      : 'Prices in ' + mode + ' are indicative, converted at today’s exchange rate' + (rateDate ? ' (' + rateDate + ')' : '') +
        '. All orders are billed in Indian Rupees (INR); your bank applies the final conversion.';
  }

  function setCountry(cc) {
    country = BY[cc] || BY.XX;
    var cur = country.cur;
    if (cur !== 'INR' && !(rates && rates[cur])) { country = BY.XX; cur = 'USD'; }
    if (cur !== 'INR' && !(rates && rates[cur])) { country = BY.IN; cur = 'INR'; }
    observe(false); restore(); mode = cur;
    if (mode !== 'INR') convert();
    observe(true); paint();
  }

  function boot() {
    buildUI();
    if (typeof MutationObserver === 'function') {
      observer = new MutationObserver(function () { if (mode !== 'INR') schedule(); });
    }
    paint();
    var cc = null, ready = 0;
    function go() { if (++ready === 2) setCountry(cc); }
    detect(function (c) { cc = c; go(); });
    getRates(function (r, d) { rates = r; rateDate = d; go(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
